<ng-template #SuccessSnackbar>
    <div fxLayout="column" class="success-box">
        <div fxLayout="row" fxLayoutAlign="end center" class="w-100-p">
            <mat-icon class="mr-8 pt-4 white-text-70" style="cursor: pointer" (click)="snackbarRef.dismiss()">
                close
            </mat-icon>
        </div>
        <div fxLayout="column" fxLayoutGap="12px" fxLayoutAlign="start start" class="pb-12 pl-12 pr-32 w-100-p">
            <span class="word-break">{{ messageText }}</span>
            <button (click)="performAction()" *ngIf="actionButton" mat-flat-button class="success-box-btn">
                {{ actionButtonText }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #ErrorSnackbar>
    <div fxLayout="column" class="error-box">
        <div fxLayout="row" fxLayoutAlign="end center" class="w-100-p">
            <mat-icon class="mr-8 pt-4 white-text-70" style="cursor: pointer" (click)="snackbarRef.dismiss()">
                close
            </mat-icon>
        </div>
        <div fxLayout="column" fxLayoutGap="12px" fxLayoutAlign="start start" class="pb-12 pl-12 pr-32 w-100-p">
            <span class="word-break">{{ messageText }}</span>
            <button (click)="performAction()" *ngIf="actionButton" mat-flat-button class="error-box-btn dark-text-80">
                {{ actionButtonText }}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #WarnSnackbar>
    <div fxLayout="column" class="warn-box">
        <div fxLayout="row" fxLayoutAlign="end center" class="w-100-p">
            <mat-icon class="mr-8 pt-4 dark-text-60" style="cursor: pointer" (click)="snackbarRef.dismiss()">
                close
            </mat-icon>
        </div>
        <div fxLayout="column" fxLayoutGap="12px" fxLayoutAlign="start start" class="pb-12 pl-12 pr-32 w-100-p">
            <span class="word-break dark-text-80">{{ messageText }}</span>
            <button (click)="performAction()" *ngIf="actionButton" mat-flat-button class="warn-box-btn dark-text-80">
                {{ actionButtonText }}
            </button>
        </div>
    </div>
</ng-template>
